import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';
import { OverlaySpinner, PageHeader } from '@insurancemenu/imenu-components-lib';
import GlobalLayout from 'components/common/general/layouts/GlobalLayout';
import { useEmployeeEmployerProfileUrlParams } from 'global/hooks/useEmployeeEmployerProfileUrlParams';
import GroupTabSwitcher from 'components/common/subscriber/GroupTabSwitcher';
import EmployerGroupProfileContent from 'components/subscriber/employer-profile/EmployerGroupProfileContent';
import EmployerSidebar from 'components/subscriber/employer-profile/EmployerSidebar';
import { useEmployerProfilePageStore } from 'store/pages/subscriber/employer-profile/pageStore';
import { RightSectionStyled, NoDataPlaceholderStyled } from './styles';

const PageContent: React.FC = observer(() => {
  const { groupId } = useEmployeeEmployerProfileUrlParams();
  const {
    isInitialLoading,
    multiLoginModule,
    isGroupsListLoading,
    setupActiveGroup,
    setActiveGroup,
    reLoginIntoActiveGroup,
  } = useEmployerProfilePageStore();

  useEffect(() => {
    void setupActiveGroup(groupId);
  }, []);

  useEffect(() => {
    if (groupId && !isGroupsListLoading) {
      setActiveGroup(groupId);
    }
  }, [groupId, isGroupsListLoading]);

  const groups = [...multiLoginModule.groupsWhereUserIsEmployee, ...multiLoginModule.groupsWhereUserIsEmployer].map(
    (group) => toJS(group),
  );
  const activeGroup = multiLoginModule.activeGroup ? toJS(multiLoginModule.activeGroup) : null;

  return (
    <>
      <OverlaySpinner display={isInitialLoading} />
      <GlobalLayout
        leftSection={isInitialLoading || !activeGroup ? null : <EmployerSidebar group={activeGroup} />}
        rightSection={
          isInitialLoading ? null : (
            <RightSectionStyled>
              <PageHeader title="Employer Dashboard" />
              <GroupTabSwitcher
                groups={groups}
                activeGroupId={activeGroup?.id ?? groupId ?? ''}
                onSelectGroup={(group) => {
                  void reLoginIntoActiveGroup(group.id, group.seUserRole);
                }}
              >
                {groups.length === 0 ? (
                  <NoDataPlaceholderStyled
                    title="No groups available"
                    text="Once you've been invited, your groups will appear here"
                  />
                ) : null}
                {activeGroup?.id ? <EmployerGroupProfileContent employerGroupId={activeGroup.id} /> : null}
              </GroupTabSwitcher>
            </RightSectionStyled>
          )
        }
      />
    </>
  );
});

export default PageContent;
